export default __webpack_public_path__ + "4b3be588979361f00aac4fa6a7b36686.png";